/*
NOTE
This section was previously known as services and therfore all the naming convention for all classes and component is 'services-*"

But this section is known as Investing Options

It is mapped to investing Options navitem in Navbar and it's id is 'options'
*/

import React, { useState, useEffect } from 'react';
import { Navigation, FreeMode } from 'swiper/modules';
import ServiceCard from './Component/ServiceCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import ServicesList from '../../Data/Services';
import './Services.css';
import { LeftRoundButton, RightRoundButton } from '../../Components/Button/RoundButton';
import SectionIds from '../../Helper/SectionId';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import SectionWithAnalytics from '../../Components/sectionWithAnalytics';


export default function Services() {
  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <SectionWithAnalytics className='section-services section-block-margin' id={SectionIds.sectionInvestingOptions}>
      <div className="header container-vertical res-gap-16 ">
        <div className="container-vertical res-gap-8">
          <div className='fs-medium fw-semibold clr-primary text-align-center '>
            Remember
          </div>
          <h3>Invest with <mark>Confidence</mark></h3>
        </div>
        <div className='fw-regular clr-grey-600 fs-medium text-align-center'>
          Explore our wide range of investment Services
        </div>
      </div>

      {isMobile ? (
        <div className="grid-container ">
          {ServicesList.map((element, index) => (
            <div className="grid-item" key={index}>
              <ServiceCard
                icon={element.icon()}
                title={element.title}
                isActive={activeCardIndex === index}
                onMouseEnter={() => setActiveCardIndex(index)}
                onMouseLeave={() => setActiveCardIndex(-1)}
              >
                <div dangerouslySetInnerHTML={{ __html: element.content }}></div>
              </ServiceCard>
            </div>
          ))}
        </div>
      ) : (
        <Swiper
          slidesPerView={1}
          spaceBetween={4}
          slidesOffsetBefore={32}
          slidesOffsetAfter={32}
          loop={true}
          freeMode={true}
          navigation={{
            nextEl: '.services-round-btn-left',
            prevEl: '.services-round-btn-right'
          }}
          modules={[FreeMode, Navigation]}
          className="services-swiper"
          breakpoints={{
            1620: {
              slidesPerView: 4,
              spaceBetween: 10,
              slidesOffsetBefore: 140,
              slidesOffsetAfter: 140
            },
            1000: {
              slidesPerView: 3,
              spaceBetween: 10,
              slidesOffsetBefore: 140,
              slidesOffsetAfter: 140
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 5,
              slidesOffsetBefore: 32,
              slidesOffsetAfter: 32
            },
            0: {
              slidesPerView: 1,
              spaceBetween: 5
            }
          }}
        >
          {ServicesList.map((element, index) => (
            <SwiperSlide key={index}>
              <ServiceCard
                initial={{
                  opacity: 0,
                  translateX: 50
                }}
                whileInView={{
                  opacity: 1,
                  translateX: 0
                }}
                transition={{
                  duration: 0.1,
                  delay: 0.1 * index,
                  transition: 'ease'
                }}
                icon={element.icon()}
                title={element.title}
                isActive={activeCardIndex === index}
                onMouseEnter={() => setActiveCardIndex(index)}
                onMouseLeave={() => setActiveCardIndex(-1)}
              >
                <div dangerouslySetInnerHTML={{ __html: element.content }}></div>
              </ServiceCard>
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      {!isMobile && (
        <div className='services-nav-btns container-horizontal res-gap-16'>
          <LeftRoundButton className='services-round-btn-left' />
          <RightRoundButton className='services-round-btn-right' />
        </div>
      )}
    </SectionWithAnalytics>
  );
}
